import { render, staticRenderFns } from "./ShareProofVideoModal.vue?vue&type=template&id=459bea6c"
import script from "./ShareProofVideoModal.vue?vue&type=script&lang=js"
export * from "./ShareProofVideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('459bea6c')) {
      api.createRecord('459bea6c', component.options)
    } else {
      api.reload('459bea6c', component.options)
    }
    module.hot.accept("./ShareProofVideoModal.vue?vue&type=template&id=459bea6c", function () {
      api.rerender('459bea6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/ShareProofVideoModal.vue"
export default component.exports